// extracted by mini-css-extract-plugin
export default {"Section":"Map_Section__13Pr4"};